import { InfrastructureService } from '../../../infrastructure/shared/services/infrastructure.service';
import { Component, OnInit, Input } from '@angular/core';
import { imgCardDrop } from '../../classes/animations';
import { FormControl } from '@angular/forms';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';
import { TypeConvention } from '../../../infrastructure/shared/classes/type_convention';

@Component({
    selector: 'app-admin-list-type-convention',
    templateUrl: './admin-list-type-convention.component.html',
    styleUrls: ['./admin-list-type-convention.component.css'],
    animations: [imgCardDrop]
})
export class AdminListTypeConventionComponent implements OnInit {

    typesConventions: TypeConvention[];
    newTypeConvention = new TypeConvention();
    selected = new FormControl(0);

    @Input()
    triggerReload: () => void;

    aclConfig: AclAccess;

    constructor(
        private infrastructureService: InfrastructureService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.typesConventions = [];
    }


    getTypeConvention() {
        this.typesConventions = [];
        this.infrastructureService.getTypesConventions()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.typesConventions.push(new TypeConvention(element));
                });
            }
        });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getTypeConvention();
        }
    }

    insertTypeConvention(typeConvention: TypeConvention) {
        this.infrastructureService.insertTypeConvention(typeConvention)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.newTypeConvention = new TypeConvention();
                if (this.triggerReload) {
                    this.triggerReload();
                }
                this.alertService.success(TRANSLATE('Type de convention ajouté avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateTypeConvention(typeConvention: TypeConvention) {
        this.infrastructureService.updateTypeConvention(typeConvention.tco_id, typeConvention)
        .subscribe(retour => {
            if (retour.status === 200) {
                if (this.triggerReload) {
                    this.triggerReload();
                }
                this.alertService.success(TRANSLATE('Type de convention modifié avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteTypeConvention(typeConvention: TypeConvention) {
        this.infrastructureService.deleteTypeConvention(typeConvention.tco_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                if (this.triggerReload) {
                    this.triggerReload();
                }
                this.alertService.success(TRANSLATE('Type de convention supprimé avec succès'));
                this.getTypeConvention();
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }
}
